import { render, staticRenderFns } from "./AccountFAB.vue?vue&type=template&id=11b95346"
import script from "./AccountFAB.vue?vue&type=script&lang=js"
export * from "./AccountFAB.vue?vue&type=script&lang=js"
import style0 from "./AccountFAB.vue?vue&type=style&index=0&id=11b95346&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports